import axios, { AxiosRequestConfig, AxiosInstance, AxiosResponse } from 'axios'
import Cookie from 'js-cookie'
import { router } from '@/router'
import { NO_NEED_LOGIN_NAMES } from '@/constants'
import { isAndroid, isIOS, isMemeShotApp } from '@/utils'
import useConfigStore from '@/store/modules/config'
// import { useAppStore } from '@/store/modules/app'

// const appStore = useAppStore()

const createInstance = (config?: AxiosRequestConfig): AxiosInstance => {
  const currentLang = Cookie.get('lang') ?? 'en_US'
  const isSupportLang = ['ar_SA', 'en_US', 'zh_CN', 'ko_KR', 'tr_TR'].includes(
    currentLang,
  )
  const instance = axios.create(
    Object.assign(
      {},
      {
        timeout: 10000,
        responseType: 'json',
        withCredentials: true,
        baseURL: '',
        headers: {
          'x-token': Cookie.get('token') ?? '',
          // 'x-language': isSupportLang ? currentLang : 'en_US',
          'Accept-Language': isSupportLang ? currentLang : 'en_US',
          'Device-Type': isMemeShotApp()
            ? isIOS()
              ? 'iOS'
              : isAndroid()
                ? 'Android'
                : 'Web'
            : 'Web',
        },
      },
      config,
    ),
  )

  // instance.interceptors.request.use((reqConfig) => {

  // })

  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      const { data, status } = response
      if (status !== 200) return Promise.reject(data)
      if (data.success) {
        return data
      } else {
        const route = router.currentRoute.value
        if (
          data?.error?.code === 3 &&
          !NO_NEED_LOGIN_NAMES.includes(route.name as string) &&
          !route.query.accessToken
        ) {
          if (!isMemeShotApp()) {
            window.isLogin = false
            const returnUrl = encodeURIComponent(window.location.href)
            location.replace(`${location.origin}/login?returnUrl=${returnUrl}`)
          } else {
            const configStore = useConfigStore()
            configStore.setErrorInfo({
              show: true,
              message: 'dex.errorLoginExpired',
              callback: () => {
                // 可以在这里添加重试逻辑
                configStore.clearErrorInfo()
              },
            })
          }
        }
        return Promise.reject(data)
      }
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  return instance
}
const request: AxiosInstance = createInstance()

export const post = (
  url: string,
  data?: any,
  config = {},
  authHeaders = false,
) => {
  const requestHeaders: Record<string, string | number> = {
    'x-token': Cookie.get('token') ?? '',
    // 'X-Session-Token': Cookie.get('sessionToken') ?? '',
    'Client-Timestamp': new Date().getTime(),
  }
  if (authHeaders) {
    requestHeaders['X-Session-Token'] = Cookie.get('sessionToken') ?? ''
  }

  return request({
    url,
    method: 'post',
    data: data || {},
    headers: requestHeaders,
    ...config,
  })
}

export const get = (
  url: string,
  params?: any,
  config = {},
  authHeaders = false,
) => {
  const requestHeaders: Record<string, string | number> = {
    'x-token': Cookie.get('token') ?? '',
    // 'X-Session-Token': Cookie.get('sessionToken') ?? '',
    'Client-Timestamp': new Date().getTime(),
  }
  if (authHeaders) {
    requestHeaders['X-Session-Token'] = Cookie.get('sessionToken') ?? ''
  }
  return request({
    url,
    method: 'get',
    params: params || {},
    headers: requestHeaders,
    ...config,
  })
}

export default request
